import { Components, Theme } from "@mui/material";
import { Shades } from "style/Colors";
import { PADDING_BASE } from "./constant";

export const MuiAccordionDetails: Components<Theme>["MuiAccordionDetails"] = {
  styleOverrides: {
    root: {
      backgroundColor: Shades.gray10,
      padding: PADDING_BASE,
    },
  },
};
